import { Component, Input, OnInit } from '@angular/core';
import { ABTestParams, FacilityBadge, MarkerDetails, StepTypes } from '../../ui/ui.types';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectIsAbTestParam } from '../../ui/ui.selectors';
import { AAAStore } from '../../../store/root-reducer';
import { selectCurrentStep } from '../../ui/ui.selectors';
import { AbstractComponent } from '../../../shared/abstract.component';

@Component({
  selector: 'drr-facility-badge',
  templateUrl: './facility-badge.component.html',
  styleUrls: ['./facility-badge.component.scss'],
})
export class DrrFacilityBadge extends AbstractComponent implements OnInit {
  @Input() markerDetails: MarkerDetails | null = null;
  @Input() badge: FacilityBadge = null
  @Input() variation: 'map' | 'card' = 'map';
  @Input() color: 'tertiary' | 'dark' | 'primary' = 'dark'
  @Input() icon: 'star' | null = null;

  isTowMapFirst$: Observable<boolean> = this.store$.pipe(
    select(selectIsAbTestParam, ABTestParams.TOW_MAP_FIRST)
  )

  isTowingStep: boolean = false;
  currentStep$: Observable<any> = this.store$.pipe(
    select(selectCurrentStep)
  )

  constructor(private store$: Store<AAAStore>) {
    super();
  }

  ngOnInit() {
    this.getBadge();
    this.subscriptions.push(
      this.currentStep$.subscribe(step => {
        this.isTowingStep = step?.url === StepTypes.TOWING;
      }),
    );
  }

  shouldDisplay() {
    return this.isTowingStep && this.markerDetails?.badge;
  }

  getBadge() {
    this.badge = this.markerDetails?.badge;

    switch (this.badge) {
      case FacilityBadge.SUGGESTED:
        this.icon = 'star';
        break;
      case FacilityBadge.YOU_ARE_HERE:
        this.color = 'primary';
        break;
      case FacilityBadge.ENTERED_LOCATION:
        this.color = 'tertiary';
        break;
    }

    if (this.markerDetails?.active) {
      this.color = 'tertiary';
    }
  }

}
